<template>
  <div class="main print-no-padding agreement-list">
    <h2 class="is-print-hide title-area">
      <span class="main-title">签约信息</span>
    </h2>
    <el-tabs v-if="load" class="tabs" v-model="activeName" type="border-card">
      <el-tab-pane class="tab-pane" :key="tab.name" v-for="tab in tabs" :label="tab.label" :name="tab.name">
        <agreement-box
          @link="linkTo"
          @change-page="handlePage"
          :agreements="tab.agreements"
          :type="tab.name"
          :currentPageNo="tab.currentPageNo"
          :total="tab.total"
          :pageSize="pageSize"
        ></agreement-box>
      </el-tab-pane>
    </el-tabs>
  </div>
</template>

<script>
import Vue from 'vue';
import { Tabs, TabPane } from 'element-ui';
import agreementBox from '@/pages/quickRoutes/agreement/components/agreementBox';

Vue.use(Tabs);
Vue.use(TabPane);

const computePaging = (arr, currPageNo, pageSize) =>
  arr.filter((o, i) => i >= (currPageNo - 1) * pageSize && i < currPageNo * pageSize);

export default {
  name: 'agreementList',
  data() {
    return {
      activeName: 'wait',
      waitAgreements: [],
      finishAgreements: [],
      currentWaitPageNo: 1,
      currentFinishPageNo: 1,
      pageSize: 10,
      load: false
    };
  },
  created() {
    Fetch.get_agreement_list().then(agreements => {
      this.waitAgreements = agreements.filter(agreement => agreement.signStatus === 0);
      this.finishAgreements = agreements.filter(agreement => agreement.signStatus === 1);
      this.activeName = this.waitAgreements.length > 0 ? 'wait' : this.finishAgreements.length > 0 ? 'finish' : 'wait';
      this.load = true;
    });
  },
  computed: {
    tabs() {
      const { waitAgreements, currentWaitPageNo, finishAgreements, currentFinishPageNo, pageSize } = this;

      const currentWaitAgreements = computePaging(waitAgreements, currentWaitPageNo, pageSize);

      const currentFinishAgreements = computePaging(finishAgreements, currentFinishPageNo, pageSize);

      return [
        {
          label: '待签署协议',
          name: 'wait',
          agreements: currentWaitAgreements,
          total: waitAgreements.length,
          currentPageNo: currentWaitPageNo
        },
        {
          label: '已签署协议',
          name: 'finish',
          agreements: currentFinishAgreements,
          total: finishAgreements.length,
          currentPageNo: currentFinishPageNo
        }
      ];
    }
  },
  methods: {
    linkTo(id) {
      this.$router.push(`/agreement/${id}`);
    },
    handlePage(pageNo, type) {
      const propertyMap = {
        wait: 'currentWaitPageNo',
        finish: 'currentFinishPageNo'
      };
      this[propertyMap[type]] = pageNo;
    }
  },
  components: {
    agreementBox
  }
};
</script>

<style lang="scss" scoped>
.agreement-list {
  //background: #fff;

  .title-area {
    margin-bottom: 16px;
  }

  .tabs {
    box-shadow: 0 4px 12px 0 rgba(237, 237, 237, 1);

    /deep/.el-tabs__item {
      /*margin-right: 1px;*/
      /*border-right: 1px solid #dcdfe6;*/
      /*border-radius: 0 12px 0 0;*/
      /*border-top: 1px solid #dcdfe6;*/
      /*border-left: none;*/
      color: #707070;

      &:hover {
        color: #1e8dff;
      }

      &.is-active {
        color: #1e8dff;
      }
    }
  }
}
</style>
